/**
 * Property report fetch actions
 */
export const PROPERTY_REPORT_FETCHED = 'PROPERTY_REPORT_FETCHED';
export function propertyReportFetched(propertyReport) {
  return {
    type: PROPERTY_REPORT_FETCHED,
    propertyReport: propertyReport,
  };
}
export const PROPERTY_REPORT_REQUEST_STARTED = 'PROPERTY_REPORT_REQUEST_STARTED';
export function propertyReportRequestStarted() {
  return {
    type: PROPERTY_REPORT_REQUEST_STARTED,
    isFetching: true,
  };
}

export const PROPERTY_REPORT_REQUEST_ERROR = 'PROPERTY_REPORT_REQUEST_ERROR';
export function propertyReportRequestError() {
  return {
    type: PROPERTY_REPORT_REQUEST_ERROR,
  };
}

// Another set of actions to get the property report wiithou any limit set
export const FULL_PROPERTY_REPORT_FETCHED = 'FULL_PROPERTY_REPORT_FETCHED';
export function fullPropertyReportFetched(fullPropertyReport) {
  return {
    type: FULL_PROPERTY_REPORT_FETCHED,
    fullPropertyReport: fullPropertyReport,
  };
}
export const FULL_PROPERTY_REPORT_REQUEST_STARTED = 'FULL_PROPERTY_REPORT_REQUEST_STARTED';
export function fullPropertyReportRequestStarted() {
  return {
    type: FULL_PROPERTY_REPORT_REQUEST_STARTED,
    isFetching: true,
  };
}

export const FULL_PROPERTY_REPORT_REQUEST_ERROR = 'FULL_PROPERTY_REPORT_REQUEST_ERROR';
export function fullPropertyReportRequestError() {
  return {
    type: FULL_PROPERTY_REPORT_REQUEST_ERROR,
  };
}
